import { regenerateIdempotencyKey } from '../idempotency';
import { setRegisteredData } from "./registered-data";

let verificationRequested = false;
//$('#modal-form-application').modal('show');////////////////////////////
//$(`section#application .result-verify`).prop('hidden', false);///////////////////

function changeStep(step) {
    $('.application-form .page-1').prop('hidden', step != 1);
    $('.application-form .page-2').prop('hidden', step != 2).prop('disabled', step != 2);
}

$('.application-form').on('submit-success', function(event, data, xhr) {
    if (!$('.page-1', this).prop('hidden')) {
        event.preventDefault();
        $(this).removeClass('was-validated');
        regenerateIdempotencyKey(this);
        changeStep(2);
        return;
    }
        
    event.assert(xhr.status == 201 && data.status == 'OK');

    $('#modal-form-application').modal('show');

    $(`section#application .result-${verificationRequested ? 'verify' : 'accept'}`).prop('hidden', false);
    $('.result-form-link').attr('href', data.formUrl);
    setRegisteredData(data, 'section#application');
    verificationRequested = false;
    changeStep(1);
});

$('.application-form').on('submit-error', function(event, xhr) {
    if (xhr.responseJSON?.formErrors?.iban) {
        changeStep(1);
    }
});

$('[name="billType"]').on('change', function() {
    $('[name="billPos"]', this.form.elements).closest('.form-group').prop('disabled', $(this).val() != 'Paragon');
}).trigger('change');

$('.application-form').on('receipt:data', function(event) {
    verificationRequested = event.originalEvent.detail.manual;
    for (const [name, value] of Object.entries(event.originalEvent.detail.values)) {
        $(this.elements[name]).val(value).trigger('input');
    }
});